export default __webpack_public_path__ + "static/media/news94.5381ee8b.jpg";